/**
 * Update date: 2024-09-30
 * Screen 2082.D
 */
import LoadPanel from 'app/components/LoadPanel';
import useDictionary from 'hooks/useDictionary';
import useFormat from 'hooks/useFormat';
import React, { createContext, useContext, useState } from 'react';

const FormSearch = React.lazy(() => import('./FormSearch'));
const List = React.lazy(() => import('./List'));

// Create context
const ModuleContext = createContext({});
ModuleContext.displayName = 'M2082_D_Context';
export const useModuleContext = () => {
  return useContext(ModuleContext);
};
/**
 * Monthly Sales Detail Inquiry
 *
 * @return {*}
 */
const M2082_D = () => {
  const { t }: any = useDictionary({ programId: '2082.D' });
  const { AmountFormat, QtyFormat, DoubleFormat } = useFormat();
  const [listData, setListData] = useState<any>({});

  // Values share with child component
  const value: any = {
    t,
    listData,
    setListData,
    AmountFormat,
    QtyFormat,
    DoubleFormat,
  };

  return (
    <ModuleContext.Provider value={value}>
      <React.Suspense fallback={<LoadPanel visible={true} />}>
        <FormSearch />
        <List />
      </React.Suspense>
    </ModuleContext.Provider>
  );
};

export default M2082_D;
